import React, { useState } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

// Placeholder SuccessMessage component (replace with your actual one)
const SuccessMessage = ({ message }) => (
  <div className="text-green-600 text-sm font-medium">{message}</div>
);

SuccessMessage.propTypes = {
  message: PropTypes.string.isRequired,
};

const LogOutModal = ({ setShowLogOutModal }) => {
  const navigate = useNavigate();
  const [success, setSuccess] = useState("");

  const handleLogout = () => {
    localStorage.removeItem("user_id");
    localStorage.removeItem("auth_token");
    sessionStorage.clear();

    setSuccess("You have been logged out successfully!");
    navigate("/login");
  };

  return (
    <div className="min-h-screen ms !h-full xsm:fixed flex items-center w-full justify-center absolute rejection-card flex-col z-30">
      <div className="bg-white w-1/2 flex flex-col items-center justify-center p-3 rounded-3xl gap-2">
        {success && <SuccessMessage message={success} />}
        <img
          // src={closeIcon}
          alt=""
          className="cursor-pointer"
          // onClick={handleRejection}
        />
        <span className="font-bold text-xl xsm:text-sm">
          Logout Confirmation
        </span>
        <span className="text-center text-sm text-[#475467]">
          Are you sure you want to logout?
        </span>
        <section className="flex gap-3 my-3">
          <button
            className="btn w-full text-white hover:bg-[#780202] bg-[#BC1518]"
            onClick={() => setShowLogOutModal(false)}
          >
            Cancel
          </button>
          <button
            className="btn w-full text-white hover:bg-[#1E4929] bg-[#049645]"
            onClick={handleLogout}
          >
            Confirm
          </button>
        </section>
      </div>
    </div>
  );
};

LogOutModal.propTypes = {
  setShowLogOutModal: PropTypes.func.isRequired,
};

export default LogOutModal;
